const Kbd = ({ children }) => (
  <kbd className="px-1.5 py-0.5 rounded border border-gray-300 border-b-2 bg-gray-50 text-[11px] font-semibold text-gray-700 font-mono">
    {children}
  </kbd>
);

export default Kbd;
